import { useNavigate } from 'react-router-dom'
import { Button } from '../components/Button'
import styles from './NotFoundPage.module.css'

export function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <div className={styles.page}>
      <span className={styles.code} aria-hidden="true">404</span>
      <h1 className={styles.title}>Página no encontrada</h1>
      <p className={styles.subtitle}>El enlace que seguiste no existe o fue movido.</p>
      <Button onClick={() => navigate('/')}>Volver al inicio</Button>
    </div>
  )
}
